/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    ProductListGICs,
    ProductSingleGICs,
    ProductTableBestGICRates,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [ProductListGICs.blockKey]: { render: ProductListGICs },
    [ProductSingleGICs.blockKey]: { render: ProductSingleGICs },
    [ProductTableBestGICRates.blockKey]: { render: ProductTableBestGICRates },
};

export default BLOCK_TO_COMPONENT_MAP;
